/**
 * Module with utility functions to validate data
 *
 */

const TEXTAREA_MAX_LENGTH = 200;
const DATE_MAX_SEND_ON_DAYS = 90;
const INPUT_NAME_MAX_LENGTH = 255;

const UK_POSTAL_CODE_REGEX = /^[0-9A-Z]{2,4}(\s)?[0-9A-Z]{3}$/;
const ZIP_CODE_REGEX = /^[0-9]{5}$/;
const PHONE_NUMBER_REGEX = /^[+]?[0-9]{10}$/;
const ORDER_NUMBER_REGEX = /^(XR-)?6[0-9]{9,}(-[0-9])*$/;
const UK_ORDER_NUMBER_REGEX = /^(XR-)?UK6[0-9]{6,}(-[0-9])*$/;

const isValidZip = (zipCode) => ZIP_CODE_REGEX.test(zipCode);
const isValidUKPostalCode = (postalCode) => UK_POSTAL_CODE_REGEX.test(postalCode);
const isValidPhoneNumber = (phoneNumber) =>
  PHONE_NUMBER_REGEX.test(phoneNumber.replace(/[\s\\-]/g, ''));
const isOrderNumber = (orderName) => {
  return ORDER_NUMBER_REGEX.test(orderName);
};
const isUkOrderNumber = (orderName) => {
  return UK_ORDER_NUMBER_REGEX.test(orderName);
};

/**
 * Validate an email address provided by the user
 *
 * @param {string} email an email address
 * @returns {boolean} with the result
 */
const isEmail = (email) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return regex.test(email);
};

/**
 * This emulate the _.isNil function from lodash
 *
 * @param {any} value
 * @returns {boolean} with the result
 */
const isNil = (value) => value === null || value === undefined;

/**
 * This emulate the _.isBoolean function from lodash
 *
 * @param {any} value
 * @returns {boolean} with the result
 */
const isBoolean = (value) => typeof value === 'boolean';

/**
 * Validate if a date a date string is valid
 */
export const isValidDate = (dateString) => {
  const dateObj = new Date(dateString);
  return !isNaN(dateObj);
};

export const nameValidator = (nameInput) =>
  nameInput?.length > 0 && nameInput?.length <= INPUT_NAME_MAX_LENGTH;

export const emailValidator = (emailInput) => isEmail(emailInput);

export const messageValidator = (messageInput) =>
  messageInput?.length > 0 && messageInput?.length <= TEXTAREA_MAX_LENGTH;

/**
 * Return date formated as Shopify required
 */
export const formatDateYYYYMMDD = (date) => new Date(date).toISOString().slice(0, 10);

/**
 * Max allowed Date on Shopify formated for HTML input type date
 */
export const maxPermitedDateYYYYMMDDFormat = () => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + DATE_MAX_SEND_ON_DAYS);
  return currentDate;
};

/**
 * Shopify can only schedule a gift card to be sent up to 90 days in the future.
 */
export const dateValidator = (dateInput) => {
  const dateNoHours = new Date(`${dateInput}T00:00:00`);
  const isDateInputValid = isValidDate(dateNoHours);
  const now = new Date();
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);
  now.setMilliseconds(0);
  const isOnPresentDate = dateNoHours >= now;
  const isBeforeMaxDate = dateNoHours <= maxPermitedDateYYYYMMDDFormat();

  return isDateInputValid && isOnPresentDate && isBeforeMaxDate;
};

export {
  isBoolean,
  isEmail,
  isNil,
  isOrderNumber,
  isUkOrderNumber,
  isValidPhoneNumber,
  isValidUKPostalCode,
  isValidZip,
};
